import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_two_wrap" }

import { reactive } from 'vue';
    import LeftMenu from './left-menu/index.vue';
    import RightCont from './right-cont/index.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

    const data = reactive({
        val:'1', //  默认为第一个
    })
    const clickEven=(val:string)=>{
        console.log(val)
        data.val = val
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(LeftMenu, { onClickChild: clickEven }),
          _createVNode(RightCont, {
            val: data.val
          }, null, 8, ["val"])
        ])
      ])
    ])
  ]))
}
}

})